import $ from 'jquery';

class Accordion {
    constructor() {
        this.accordion = $('.accordion');
        this.accordionCollapse = $('.accordion .collapse');
        this.collapseBtn = $('.collapse > .btn');
        //this.accordionCollapseBtn = $('.careers__vacancy-btn');
        this.collapseContent = this.accordionCollapse.find('.collapse__content');
        this.events();
    }

    events() {
        var show = false;

        this.collapseBtn.click(function () {
            var button = $(this).find('.careers__vacancy-btn'),
                buttonText = $(button).text();
                if( buttonText == 'VIEW DETAILS' ) {
                    button.addClass('careers__vacancy-btn--close').text('CLOSE DETAILS')
                }else {
                    button.removeClass('careers__vacancy-btn--close').text('VIEW DETAILS')
                }
            $(this).toggleClass('collapsed');
            $(this).siblings('.collapse__content').slideToggle();

            $(this).parent().siblings().find('[data-toggle]').removeClass('collapsed')
            $(this).parent().siblings().find('.collapse__content').slideUp();
        })
    }
}

export default Accordion;
